"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = require("@react-pdf/renderer");
var React = __importStar(require("react"));
var Card_1 = __importDefault(require("../Card"));
var CardAttribute_1 = __importDefault(require("../CardAttribute"));
var style = renderer_1.StyleSheet.create({
    text: {
        fontFamily: "Quicksand",
        fontSize: 10,
    },
});
var BatchCard = function (_a) {
    var lotOrBatchNumber = _a.lotOrBatchNumber, sourceUID = _a.sourceUID, packageUID = _a.packageUID;
    return (React.createElement(Card_1.default, { style: { width: 200, paddingVertical: 5, marginBottom: 5 } },
        React.createElement(renderer_1.Text, { style: style.text }, "Batch"),
        React.createElement(CardAttribute_1.default, { title: "Lot / Batch", value: lotOrBatchNumber }),
        sourceUID && React.createElement(CardAttribute_1.default, { title: "Source UID", value: sourceUID }),
        packageUID && React.createElement(CardAttribute_1.default, { title: "Package UID", value: packageUID })));
};
exports.default = BatchCard;
//# sourceMappingURL=index.js.map